export default __webpack_public_path__ + "static/nordvik-logo-868244ed9d9f065f704ff6f53eec0f34.jpg";